import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {STATISTICS_PERIODS} from '../constants';
import {FormGroup, FormControl, ControlLabel} from 'react-bootstrap';


@injectIntl @inject('analyticsStore') @observer
export default class TicketsCountBox extends React.Component{
    render(){
        const {intl, analyticsStore} = this.props;
        return (
            <FormGroup controlId="formControlsSelect">
              <ControlLabel>{intl.formatMessage({id: 'select_period_label'})}</ControlLabel>
              <FormControl value={analyticsStore.period} componentClass="select" placeholder="select" onChange={this.handleSelect}>
                <option value={STATISTICS_PERIODS.MONTHLY}>{intl.formatMessage({id: 'monthly_period_label'})}</option>
                <option value={STATISTICS_PERIODS.ANNUALLY}>{intl.formatMessage({id: 'yearly_period_label'})}</option>
              </FormControl>
            </FormGroup>
        );
    }

    handleSelect = (e) =>{
        this.props.analyticsStore.setPeriod(e.target.value);
    }
};